import axios from 'axios';
import {APIURL} from '../../constants';
import {translater} from '../../tools/translate';
import {roles} from '../../constants/users';

export default {
	namespaced: true,
	state: {
		search: '',
		loading: false,
		users: [],
		usersDT: [],
		id: undefined,
		username: '',
		role: 'moderator',
		password: undefined,
		passwordConfirmation: undefined,
		roles: roles,
		showDeleteConfirmation: false,
		selected: undefined

		
	},

	actions: {
		indexDT(context)
		{
			context.state.usersDT = []
			axios.get(APIURL + 'users')
			.then((res) => {

				context.commit('loading', false);
				context.commit('indexDT', res.data);

			})
			.catch(() => {
				context.commit('loading', false);
				//console.log(err);
			})
			
		},

		setSelected(context, payload)
		{
			context.commit('setSelected', payload);
		},

		getEdit(context, payload)
		{
			axios.get(APIURL + 'users/edit/' + payload)
			.then((res) => {
				context.commit('get', res.data)
			})
			.catch(() => {
				//console.log(err)
			})
		},

		update(context)
		{
			let id = context.state.id;
			let username = context.state.username;
			let role = context.state.role;

			return axios.put(APIURL + 'users/update/' + id, {
				username: username,
				role: role
			})
		},

		store(context)
		{
			let user = {
				username: context.state.username,
				password: context.state.password,
				role: context.state.role
			};

			return axios.post(APIURL + 'users', user);

		},

		destroy(context)
		{
			return axios.delete(APIURL + 'users/' + context.state.selected.id)
		},

		flush(context)
		{
			context.commit('flush');
		},

		setUsername(context, payload)
		{
			context.commit('setUsername', payload);
		},

		setPassword(context, payload)
		{
			context.commit('setPassword', payload);
		},

		setPasswordConfirmation(context, payload)
		{
			context.commit('setPasswordConfirmation', payload);
		},

		setSearch(context, payload)
		{
			context.commit('setSearch', payload);
		},

		setRole(context, payload)
		{
			context.commit('setRole', payload);
		},

		setShowDeleteConfirmation(context, payload)
		{
			context.commit('setShowDeleteConfirmation', payload);
		},

		loading(context, payload)
		{
			context.commit('loading', payload)
		},

		changePassword(context)
		{
			return axios.put(APIURL + 'users/change-password/' + context.state.id, {
				password: context.state.password
			});
		}
	},

	getters: {

		loading(state)
		{
			return state.loading;
		},

		indexDT(state)
		{
			return state.usersDT;
		},

		get(state)
		{
			
			return {
				username: state.username,
				password: state.password
				
			};
		},

		search(state)
		{
			return state.search
		},

		roles(state)
		{
			return state.roles;
		},

		role(state)
		{
			return state.role;
		},

		showDeleteConfirmation(state)
		{
			return state.showDeleteConfirmation;
		},

		selected(state)
		{
			return state.selected;
		}
	},

	mutations: {
		indexDT(state, payload)
		{
			payload.forEach((u) => {
				
				state.usersDT.push({
					value: false,
					id: u._id,
					username: u.username,
					role: translater.__(u.role, 'users')

				});
			});
		},

		get(state, payload)
		{
			
			state.username = payload.username;
			state.id = payload._id
			state.role = payload.role
		},

		flush(state)
		{
			state.username = '';
			state.password = undefined;
			state.id = undefined;
			state.role = 'moderator';
			state.passwordConfirmation = undefined;

			

		},

		loading(state, payload)
		{
			state.loading = payload;
		},

		setUsername(state, payload)
		{
			state.username = payload;
		},

		setPassword(state, payload)
		{
			
			state.password = payload;
		},

		setPasswordConfirmation(state, payload)
		{
			state.passwordConfirmation = payload;
		},

		setSearch(state, payload)
		{
			state.search = payload;
		},

		setRole(state, payload)
		{
			state.role = payload
		},

		setShowDeleteConfirmation(state, payload)
		{
			state.showDeleteConfirmation = payload
		},

		setSelected(state, payload)
		{
			state.selected = payload;
		}




	}

}